import { render, staticRenderFns } from "./PersonOverview.vue?vue&type=template&id=4d5c3731&scoped=true"
import script from "./PersonOverview.vue?vue&type=script&lang=js"
export * from "./PersonOverview.vue?vue&type=script&lang=js"
import style0 from "./PersonOverview.vue?vue&type=style&index=0&id=4d5c3731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c3731",
  null
  
)

export default component.exports